import { render, staticRenderFns } from "./OrganisationsPage.vue?vue&type=template&id=b76619d8"
import script from "./OrganisationsPage.vue?vue&type=script&lang=js"
export * from "./OrganisationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b76619d8')) {
      api.createRecord('b76619d8', component.options)
    } else {
      api.reload('b76619d8', component.options)
    }
    module.hot.accept("./OrganisationsPage.vue?vue&type=template&id=b76619d8", function () {
      api.rerender('b76619d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/OrganisationsPage.vue"
export default component.exports